import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

/*
*   ViewModel and Template not multilingualized, as this pane is for developrs
*   in a strictly B2B context.
*/

export class TemplateViewModel {
    ShowAlert:                     (pTitle: string, pMessage: string) => void;
    BackToSignIn:                  ()                                 => void;
    NewLoading:                    (pMessage: string)                 => dmLoading;

    mlText:                        MLText;
    app:                           mlBroker;
    ml:                            mlBroker;
    Hotel:                         dmHotel;
    LangID:                        number;

    Settings:                      RQService.Ota.GetHotelEngineServiceTemplateSettingsRow;

    WithFontFamily:                boolean;
    WithDefaultButtonOverride:     boolean;
    WithInfoButtonOverride:        boolean;
    WithSuccessButtonOverride:     boolean;
    WithWarningButtonOverride:     boolean;
    WithDangerButtonOverride:      boolean;
    WithOutlineInfoButtonOverride: boolean;

    DefaultButtonShadowRed:        string;
    DefaultButtonShadowGreen:      string;
    DefaultButtonShadowBlue:       string;

    InfoButtonShadowRed:           string;
    InfoButtonShadowGreen:         string;
    InfoButtonShadowBlue:          string;

    SuccessButtonShadowRed:        string;
    SuccessButtonShadowGreen:      string;
    SuccessButtonShadowBlue:       string;

    WarningButtonShadowRed:        string;
    WarningButtonShadowGreen:      string;
    WarningButtonShadowBlue:       string;

    DangerButtonShadowRed:         string;
    DangerButtonShadowGreen:       string;
    DangerButtonShadowBlue:        string;

    InfoOutlineButtonShadowRed:    string;
    InfoOutlineButtonShadowGreen:  string;
    InfoOutlineButtonShadowBlue:   string;

    ValidateFontFamily:            RegExp = /^[0-9a-zA-Z,\- ]*$/;
    ValidateColor:                 RegExp = /^[0-9a-zA-Z#]+$/;
    ValidateColorOrEmpty:          RegExp = /^[0-9a-zA-Z#]*$/;
    ValidateInteger:               RegExp = /^[0-9]+$/;

    constructor(
         pMLText:         MLText
        ,pHotel:          dmHotel
        ,pBackToSignIn:   ()                                 => void
        ,pShowAlert:      (pTitle: string, pMessage: string) => void
        ,pNewLoading:     (pMessage: string)                 => dmLoading
    ) {
        this.mlText       = pMLText;
        this.LangID       = this.mlText.GetLangID();
        this.app          = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml           = this.mlText.GetBroker(
            'HotelAreaTemplate'
        );

        this.Hotel        = pHotel;
        this.BackToSignIn = pBackToSignIn;
        this.ShowAlert    = pShowAlert;
        this.NewLoading   = pNewLoading;

        this.Settings     = RQService.Ota.PopulateGetHotelEngineServiceTemplateSettingsRow({});

        this.refreshSettings();
    }

    private refreshSettings(): void {
        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            let settingsParams = RQParam.OtaGetHotelEngineServiceTemplateSettingsParams();

            settingsParams.HotelID = this.Hotel.HotelID;

            RQService.Ota.GetHotelEngineServiceTemplateSettings(settingsParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                let settingsList = response.RQueryResult;

                this.Settings = RQService.Ota.PopulateGetHotelEngineServiceTemplateSettingsRow(
                    settingsList[0]
                );

                this.WithFontFamily            = (this.Settings.WithFontFamily            == 1);
                this.WithDefaultButtonOverride = (this.Settings.WithDefaultButtonOverride == 1);
                this.WithInfoButtonOverride    = (this.Settings.WithInfoButtonOverride    == 1);
                this.WithSuccessButtonOverride = (this.Settings.WithSuccessButtonOverride == 1);
                this.WithWarningButtonOverride = (this.Settings.WithWarningButtonOverride == 1);
                this.WithDangerButtonOverride  = (this.Settings.WithDangerButtonOverride  == 1);
                this.WithOutlineInfoButtonOverride
                    = (this.Settings.WithOutlineInfoButtonOverride == 1);

                let rgbDefault:     string[] = this.Settings.DefaultButtonShadowRGB.split(',').map(
                    rgb => rgb.trim()
                );

                let rgbInfo:        string[] = this.Settings.InfoButtonShadowRGB.split(   ',').map(
                    rgb => rgb.trim()
                );

                let rgbSuccess:     string[] = this.Settings.SuccessButtonShadowRGB.split(',').map(
                    rgb => rgb.trim()
                );

                let rgbWarning:     string[] = this.Settings.WarningButtonShadowRGB.split(',').map(
                    rgb => rgb.trim()
                );

                let rgbDanger:      string[] = this.Settings.DangerButtonShadowRGB.split( ',').map(
                    rgb => rgb.trim()
                );

                let rgbInfoOutline: string[] = this.Settings.InfoOutlineButtonShadowRGB.split(
                    ','
                ).map(
                    rgb => rgb.trim()
                );

                if (this.WithDefaultButtonOverride) {
                    this.DefaultButtonShadowRed       = rgbDefault[0];
                    this.DefaultButtonShadowGreen     = rgbDefault[0];
                    this.DefaultButtonShadowBlue      = rgbDefault[0];
                } else {
                    this.DefaultButtonShadowRed       = '0';
                    this.DefaultButtonShadowGreen     = '0';
                    this.DefaultButtonShadowBlue      = '0';
                }

                if (this.WithInfoButtonOverride) {
                    this.InfoButtonShadowRed          = rgbInfo[0];
                    this.InfoButtonShadowGreen        = rgbInfo[0];
                    this.InfoButtonShadowBlue         = rgbInfo[0];
                } else {
                    this.InfoButtonShadowRed          = '0';
                    this.InfoButtonShadowGreen        = '0';
                    this.InfoButtonShadowBlue         = '0';
                }

                if (this.WithSuccessButtonOverride) {
                    this.SuccessButtonShadowRed       = rgbSuccess[0];
                    this.SuccessButtonShadowGreen     = rgbSuccess[0];
                    this.SuccessButtonShadowBlue      = rgbSuccess[0];
                } else {
                    this.SuccessButtonShadowRed       = '0';
                    this.SuccessButtonShadowGreen     = '0';
                    this.SuccessButtonShadowBlue      = '0';
                }

                if (this.WithWarningButtonOverride) {
                    this.WarningButtonShadowRed       = rgbWarning[0];
                    this.WarningButtonShadowGreen     = rgbWarning[0];
                    this.WarningButtonShadowBlue      = rgbWarning[0];
                } else {
                    this.WarningButtonShadowRed       = '0';
                    this.WarningButtonShadowGreen     = '0';
                    this.WarningButtonShadowBlue      = '0';
                }

                if (this.WithDangerButtonOverride) {
                    this.DangerButtonShadowRed        = rgbDanger[0];
                    this.DangerButtonShadowGreen      = rgbDanger[0];
                    this.DangerButtonShadowBlue       = rgbDanger[0];
                } else {
                    this.DangerButtonShadowRed        = '0';
                    this.DangerButtonShadowGreen      = '0';
                    this.DangerButtonShadowBlue       = '0';
                }

                if (this.WithOutlineInfoButtonOverride) {
                    this.InfoOutlineButtonShadowRed   = rgbInfoOutline[0];
                    this.InfoOutlineButtonShadowGreen = rgbInfoOutline[0];
                    this.InfoOutlineButtonShadowBlue  = rgbInfoOutline[0];
                } else {
                    this.InfoOutlineButtonShadowRed   = '0';
                    this.InfoOutlineButtonShadowGreen = '0';
                    this.InfoOutlineButtonShadowBlue  = '0';
                }

                loading.Dismiss();
            });
        });
    }

    private validateSettings(): boolean {
        let colorInvalid:        string = ' must be a valid web color name, '
          + 'or hex color with hash sign.';
        let colorOrEmptyInvalid: string = ' must be empty, or a valid web color name, '
          + 'or hex color with hash sign.'
        let integerInvalid: string      = ' must be a whole number from 0 to 255';

        if (!this.ValidateFontFamily.test(this.Settings.FontFamily.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'FontFamily must be empty, or a valid comma seperated list of font names.'
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.Background.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'Background' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.MainText.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'MainText' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.MutedText.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'MutedText' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.DescriptionText.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'DescriptionText' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.MenuItemTickUnckecked.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'MenuItemTickUnckecked' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.ActionOK.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'ActionOK' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.ActionWithNote.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'ActionWithNote' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.DeleteAndWarning.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'DeleteAndWarning' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.SignInDividerBackground.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'SignInDividerBackground' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.SignInDividerText.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'SignInDividerText' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.SearchAndCartBackground.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'SearchAndCartBackground' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.SearchAndCartDivider.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'SearchAndCartDivider' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.SearchAndCartTitle.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'SearchAndCartTitle' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.DropdownBackground.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'DropdownBackground' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.CartSummaryBackground.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'CartSummaryBackground' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.CartSummaryBorder.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'CartSummaryBorder' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.OfferSelectedBackground.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'OfferSelectedBackground' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.OfferSelectedBorder.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'OfferSelectedBorder' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.UtilityLinkText.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'UtilityLinkText' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.ButtonDisabledBackground.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'ButtonDisabledBackground' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.ButtonDisabledBorder.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'ButtonDisabledBorder' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColor.test(this.Settings.ButtonDisabledText.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'ButtonDisabledText' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.DefaultButtonText.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'DefaultButtonText' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.DefaultButtonBackground.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'DefaultButtonBackground' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.DefaultButtonBackgroundHover.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'DefaultButtonBackgroundHover' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.DefaultButtonBorderHover.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'DefaultButtonBorderHover' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.DefaultButtonBorderActive.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'DefaultButtonBorderActive' + colorInvalid
            );
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.InfoButtonText.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'InfoButtonText' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.InfoButtonBackground.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'InfoButtonBackground' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.InfoButtonBackgroundHover.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'InfoButtonBackgroundHover' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.InfoButtonBorderHover.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'InfoButtonBorderHover' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.InfoButtonBorderActive.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'InfoButtonBorderActive' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.SuccessButtonText.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'SuccessButtonText' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.SuccessButtonBackground.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'SuccessButtonBackground' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.SuccessButtonBackgroundHover.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'SuccessButtonBackgroundHover' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.SuccessButtonBorderHover.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'SuccessButtonBorderHover' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.SuccessButtonBorderActive.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'SuccessButtonBorderActive' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.WarningButtonText.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'WarningButtonText' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.WarningButtonBackground.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'WarningButtonBackground' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.WarningButtonBackgroundHover.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'WarningButtonBackgroundHover' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.WarningButtonBorderHover.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'WarningButtonBorderHover' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.WarningButtonBorderActive.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'WarningButtonBorderActive' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.DangerButtonText.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'DangerButtonText' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.DangerButtonBackground.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'DangerButtonBackground' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.DangerButtonBackgroundHover.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'DangerButtonBackgroundHover' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.DangerButtonBorderHover.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'DangerButtonBorderHover' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.DangerButtonBorderActive.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'DangerButtonBorderActive' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.InfoOutlineButtonBackground.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'InfoOutlineButtonBackground' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateColorOrEmpty.test(this.Settings.InfoOutlineButtonContent.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'InfoOutlineButtonContent' + colorInvalid
            );

            return false;
        }

        if (!this.ValidateInteger.test(this.DefaultButtonShadowRed.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'DefaultButtonShadowRed' + integerInvalid
            );

            return false;
        }

        if (!this.ValidateInteger.test(this.DefaultButtonShadowGreen.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'DefaultButtonShadowGreen' + integerInvalid
            );

            return false;
        }

        if (!this.ValidateInteger.test(this.DefaultButtonShadowBlue.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'DefaultButtonShadowBlue' + integerInvalid
            );

            return false;
        }

        if (!this.ValidateInteger.test(this.InfoButtonShadowRed.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'InfoButtonShadowRed' + integerInvalid
            );

            return false;
        }

        if (!this.ValidateInteger.test(this.InfoButtonShadowGreen.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'InfoButtonShadowGreen' + integerInvalid
            );

            return false;
        }

        if (!this.ValidateInteger.test(this.InfoButtonShadowBlue.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'InfoButtonShadowBlue' + integerInvalid
            );

            return false;
        }

        if (!this.ValidateInteger.test(this.SuccessButtonShadowRed.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'SuccessButtonShadowRed' + integerInvalid
            );

            return false;
        }

        if (!this.ValidateInteger.test(this.SuccessButtonShadowGreen.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'SuccessButtonShadowGreen' + integerInvalid
            );

            return false;
        }

        if (!this.ValidateInteger.test(this.SuccessButtonShadowBlue.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'SuccessButtonShadowBlue' + integerInvalid
            );

            return false;
        }

        if (!this.ValidateInteger.test(this.WarningButtonShadowRed.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'WarningButtonShadowRed' + integerInvalid
            );

            return false;
        }

        if (!this.ValidateInteger.test(this.WarningButtonShadowGreen.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'WarningButtonShadowGreen' + integerInvalid
            );

            return false;
        }

        if (!this.ValidateInteger.test(this.WarningButtonShadowBlue.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'WarningButtonShadowBlue' + integerInvalid
            );

            return false;
        }

        if (!this.ValidateInteger.test(this.DangerButtonShadowRed.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'DangerButtonShadowRed' + integerInvalid
            );

            return false;
        }

        if (!this.ValidateInteger.test(this.DangerButtonShadowGreen.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'DangerButtonShadowGreen' + integerInvalid
            );

            return false;
        }

        if (!this.ValidateInteger.test(this.DangerButtonShadowBlue.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'DangerButtonShadowBlue' + integerInvalid
            );

            return false;
        }

        if (!this.ValidateInteger.test(this.InfoOutlineButtonShadowRed.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'InfoOutlineButtonShadowRed' + integerInvalid
            );

            return false;
        }

        if (!this.ValidateInteger.test(this.InfoOutlineButtonShadowGreen.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'InfoOutlineButtonShadowGreen' + integerInvalid
            );

            return false;
        }

        if (!this.ValidateInteger.test(this.InfoOutlineButtonShadowBlue.trim())) {
            this.ShowAlert(
                 'Invalid Field'
                ,'InfoOutlineButtonShadowBlue' + integerInvalid
            );

            return false;
        }

        return true;
    }

    public Reset(): void { this.refreshSettings(); }

    public Save(): void {
        if (!this.validateSettings()) { return; }

        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            let saveParams = RQParam.OtaEditHotelEngineServiceTemplateParams();

            saveParams.HotelID                      = this.Hotel.HotelID;

            saveParams.WithFontFamily               = (this.WithFontFamily)            ? 1 : 0;
            saveParams.WithDefaultButtonOverride    = (this.WithDefaultButtonOverride) ? 1 : 0;
            saveParams.WithInfoButtonOverride       = (this.WithInfoButtonOverride)    ? 1 : 0;
            saveParams.WithSuccessButtonOverride    = (this.WithSuccessButtonOverride) ? 1 : 0;
            saveParams.WithWarningButtonOverride    = (this.WithWarningButtonOverride) ? 1 : 0;
            saveParams.WithDangerButtonOverride     = (this.WithDangerButtonOverride)  ? 1 : 0;
            saveParams.WithOutlineInfoButtonOverride
                = (this.WithOutlineInfoButtonOverride) ? 1 : 0;

            saveParams.FontFamily                   = this.Settings.FontFamily.trim();
            saveParams.Background                   = this.Settings.Background.trim();
            saveParams.MainText                     = this.Settings.MainText.trim();
            saveParams.MutedText                    = this.Settings.MutedText.trim();
            saveParams.DescriptionText              = this.Settings.DescriptionText.trim();
            saveParams.MenuItemTickUnckecked        = this.Settings.MenuItemTickUnckecked.trim();
            saveParams.ActionOK                     = this.Settings.ActionOK.trim();
            saveParams.ActionWithNote               = this.Settings.ActionWithNote.trim();
            saveParams.DeleteAndWarning             = this.Settings.DeleteAndWarning.trim();
            saveParams.SignInDividerBackground      = this.Settings.SignInDividerBackground.trim();
            saveParams.SignInDividerText            = this.Settings.SignInDividerText.trim();
            saveParams.SearchAndCartBackground      = this.Settings.SearchAndCartBackground.trim();
            saveParams.SearchAndCartDivider         = this.Settings.SearchAndCartDivider.trim();
            saveParams.SearchAndCartTitle           = this.Settings.SearchAndCartTitle.trim();
            saveParams.DropdownBackground           = this.Settings.DropdownBackground.trim();
            saveParams.CartSummaryBackground        = this.Settings.CartSummaryBackground.trim();
            saveParams.CartSummaryBorder            = this.Settings.CartSummaryBorder.trim();
            saveParams.OfferSelectedBackground      = this.Settings.OfferSelectedBackground.trim();
            saveParams.OfferSelectedBorder          = this.Settings.OfferSelectedBorder.trim();
            saveParams.UtilityLinkText              = this.Settings.UtilityLinkText.trim();
            saveParams.ButtonDisabledBackground     = this.Settings.ButtonDisabledBackground.trim();
            saveParams.ButtonDisabledBorder         = this.Settings.ButtonDisabledBorder.trim();
            saveParams.ButtonDisabledText           = this.Settings.ButtonDisabledText.trim();

            saveParams.DefaultButtonText            = this.Settings.DefaultButtonText.trim();
            saveParams.DefaultButtonBackground      = this.Settings.DefaultButtonBackground.trim();
            saveParams.DefaultButtonBackgroundHover = this.Settings.DefaultButtonBackgroundHover.trim();
            saveParams.DefaultButtonBorderHover     = this.Settings.DefaultButtonBorderHover.trim();
            saveParams.DefaultButtonShadowRed       = Number(this.DefaultButtonShadowRed.trim());
            saveParams.DefaultButtonShadowGreen     = Number(this.DefaultButtonShadowGreen.trim());
            saveParams.DefaultButtonShadowBlue      = Number(this.DefaultButtonShadowBlue.trim());
            saveParams.DefaultButtonBorderActive    = this.Settings.DefaultButtonBorderActive.trim();

            saveParams.InfoButtonText               = this.Settings.InfoButtonText.trim();
            saveParams.InfoButtonBackground         = this.Settings.InfoButtonBackground.trim();
            saveParams.InfoButtonBackgroundHover    = this.Settings.InfoButtonBackgroundHover.trim();
            saveParams.InfoButtonBorderHover        = this.Settings.InfoButtonBorderHover.trim();
            saveParams.InfoButtonShadowRed          = Number(this.InfoButtonShadowRed.trim());
            saveParams.InfoButtonShadowGreen        = Number(this.InfoButtonShadowGreen.trim());
            saveParams.InfoButtonShadowBlue         = Number(this.InfoButtonShadowBlue.trim());
            saveParams.InfoButtonBorderActive       = this.Settings.InfoButtonBorderActive.trim();

            saveParams.SuccessButtonText            = this.Settings.SuccessButtonText.trim();
            saveParams.SuccessButtonBackground      = this.Settings.SuccessButtonBackground.trim();
            saveParams.SuccessButtonBackgroundHover = this.Settings.SuccessButtonBackgroundHover.trim();
            saveParams.SuccessButtonBorderHover     = this.Settings.SuccessButtonBorderHover.trim();
            saveParams.SuccessButtonShadowRed       = Number(this.SuccessButtonShadowRed.trim());
            saveParams.SuccessButtonShadowGreen     = Number(this.SuccessButtonShadowGreen.trim());
            saveParams.SuccessButtonShadowBlue      = Number(this.SuccessButtonShadowBlue.trim());
            saveParams.SuccessButtonBorderActive    = this.Settings.SuccessButtonBorderActive.trim();

            saveParams.WarningButtonText            = this.Settings.WarningButtonText.trim();
            saveParams.WarningButtonBackground      = this.Settings.WarningButtonBackground.trim();
            saveParams.WarningButtonBackgroundHover = this.Settings.WarningButtonBackgroundHover.trim();
            saveParams.WarningButtonBorderHover     = this.Settings.WarningButtonBorderHover.trim();
            saveParams.WarningButtonShadowRed       = Number(this.WarningButtonShadowRed.trim());
            saveParams.WarningButtonShadowGreen     = Number(this.WarningButtonShadowGreen.trim());
            saveParams.WarningButtonShadowBlue      = Number(this.WarningButtonShadowBlue.trim());
            saveParams.WarningButtonBorderActive    = this.Settings.WarningButtonBorderActive.trim();

            saveParams.DangerButtonText             = this.Settings.DangerButtonText.trim();
            saveParams.DangerButtonBackground       = this.Settings.DangerButtonBackground.trim();
            saveParams.DangerButtonBackgroundHover  = this.Settings.DangerButtonBackgroundHover.trim();
            saveParams.DangerButtonBorderHover      = this.Settings.DangerButtonBorderHover.trim();
            saveParams.DangerButtonShadowRed        = Number(this.DangerButtonShadowRed.trim());
            saveParams.DangerButtonShadowGreen      = Number(this.DangerButtonShadowGreen.trim());
            saveParams.DangerButtonShadowBlue       = Number(this.DangerButtonShadowBlue.trim());
            saveParams.DangerButtonBorderActive     = this.Settings.DangerButtonBorderActive.trim();

            saveParams.InfoOutlineButtonContent     = this.Settings.InfoOutlineButtonContent.trim();
            saveParams.InfoOutlineButtonBackground  = this.Settings.InfoOutlineButtonBackground.trim();
            saveParams.InfoOutlineButtonShadowRed   = Number(this.InfoOutlineButtonShadowRed.trim());
            saveParams.InfoOutlineButtonShadowGreen = Number(this.InfoOutlineButtonShadowGreen.trim());
            saveParams.InfoOutlineButtonShadowBlue  = Number(this.InfoOutlineButtonShadowBlue.trim());

            RQService.Ota.EditHotelEngineServiceTemplate(saveParams).then((result) => {
                loading.Dismiss();

                let response = result as any;

                if (response.HasErrorOrException) {
                    this.refreshSettings();
                }
            });
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/template/xv-template.ts